<div class="col-md-12 mr-auto ml-auto dropdown-container">
  <table class="table table-bordered">
    <thead class="thead-dark">
      <tr>
        <th>Customer</th>
        <th>Countries</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of customers">
        <td>{{item.name}}</td>
        <td>
          <angular-multiselect
            [data]="itemList"
            [(ngModel)]="item.countries"
            [settings]="settings"
            (onSelect)="onItemSelect($event)"
            (onDeSelect)="OnItemDeSelect($event)"
            (onSelectAll)="onSelectAll($event)"
            (onDeSelectAll)="onDeSelectAll($event)"
          >
          </angular-multiselect>
        </td>
      </tr>
    </tbody>
  </table>
  {{customers | json}}
</div>